import { render, staticRenderFns } from "./Alldate.vue?vue&type=template&id=5088ec96&scoped=true&"
import script from "./Alldate.vue?vue&type=script&lang=js&"
export * from "./Alldate.vue?vue&type=script&lang=js&"
import style0 from "./Alldate.vue?vue&type=style&index=0&id=5088ec96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088ec96",
  null
  
)

export default component.exports